<div class="form-control-validation">
    <div class="alert alert--validation" role="alert" aria-live="polite">
        <svg class="alert__icon svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#cross-closed"></use></svg>
        <ng-content></ng-content>
    </div>
</div>
